import {MenuItem as MuiMenuItem, styled} from '@mui/material';

const MenuItem = styled(MuiMenuItem)(({theme}) => {

  return ({
    fontFamily: "RedotPay",
    fontSize: "14px",
    lineHeight: 1,
    color: theme.palette.text.primary,
    // padding:"4px 16px",
    minHeight: "32px",
  })
});

export {MenuItem}
